import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { ChampsFusionService } from '@core/services/champs-fusion.service';
import { AdressesDestinatairesService, GlobalDataService, PersonalisationService } from '@core/services';
import { MatStepper } from '@angular/material/stepper';
import { debounceTime, distinctUntilChanged, fromEvent, map } from 'rxjs';
import { ChampsFusion } from '@core/models/champsFusion.model';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
@Component({
  selector: 'app-campagne-personnalisation',
  templateUrl: './campagne-personnalisation.component.html',
  styleUrls: ['./campagne-personnalisation.component.scss']
})
export class CampagnePersonnalisationComponent implements OnInit, OnDestroy {


  @ViewChild('champFusionRef') private champFusionRef!: ElementRef;

  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;

  constructor(
    private _stepper: MatStepper,
    public _GlobalDataService: GlobalDataService,
    public _ChampsFusionService: ChampsFusionService,
    public personalisationService: PersonalisationService,
    public  adressesDestinatairesService: AdressesDestinatairesService,
  ) {

  }

  ngOnInit() {
    // Initialization of dual-list services is performed by the parent
    // `CampagneDetailsService.gotoDetailCampagne()` to guarantee
    // backend data (and any persisted draft) is applied before building
    // the lists. Avoid double initialisation here which caused a race
    // between an early catalogue fetch and the draft rehydration.
  }


  ngAfterViewInit() {

    setTimeout(() => {
      this.viewport?.checkViewportSize();
    });

    const keyup2$ = fromEvent(
      this.champFusionRef.nativeElement,
      'keyup'
    );


    // wait .5s between keyups to emit current value
    keyup2$
      .pipe(
        map((event: any) => event.currentTarget.value),
        debounceTime(300),
        distinctUntilChanged(),
        map(value => this.filterChampsFusion(value)),
      )
      .subscribe((result) => {
        this.personalisationService.filteredAvailableChampsFusion = result;
      });
  }


  private filterChampsFusion(champFusionName: string): any[] {
    const selectedKeys = new Set(
      this.personalisationService.selectedChampsFusion
        .map(cf => this.personalisationService.getChampFusionKey(cf))
        .filter((key): key is string => !!key)
    );

    return this.personalisationService.availableChampsFusion
      .filter(cf => cf.ChampFusion.toLowerCase().includes(champFusionName.toLowerCase()))
      .filter(cf => {
        const key = this.personalisationService.getChampFusionKey(cf);
        return !key || !selectedKeys.has(key);
      });
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
    this.updatePersonalisationCompletion();
  }

  selectChampFusion(champsFusion: ChampsFusion) {
    transferArrayItem(
      this.personalisationService.filteredAvailableChampsFusion,
      this.personalisationService.selectedChampsFusion,
      this.personalisationService.filteredAvailableChampsFusion.indexOf(champsFusion),
      this.personalisationService.selectedChampsFusion.length - 1
    );
    this.updatePersonalisationCompletion();
  }

  unselectChampFusion(champsFusion: ChampsFusion) {
    transferArrayItem(
      this.personalisationService.selectedChampsFusion,
      this.personalisationService.filteredAvailableChampsFusion,
      this.personalisationService.selectedChampsFusion.indexOf(champsFusion),
      this.personalisationService.filteredAvailableChampsFusion.length - 1
    );
    this.updatePersonalisationCompletion();
  }

  Vider() {
    this.personalisationService.filteredAvailableChampsFusion = this.personalisationService.filteredAvailableChampsFusion.concat(this.personalisationService.selectedChampsFusion);
    this.personalisationService.selectedChampsFusion = [];
    this.updatePersonalisationCompletion();
  }

  submit() {
    this._stepper.next();
  }

  ngOnDestroy() {
  }

  private updatePersonalisationCompletion() {
    this.personalisationService.setChampFusionType();
    this._GlobalDataService.CampagneExt.ChampsFusion =
      this.personalisationService.selectedChampsFusion.concat(
        this.adressesDestinatairesService.selectedChampsFusion
      );
    this._GlobalDataService.saveCampaignDraft(this._GlobalDataService.Campagne, this._GlobalDataService.CampagneExt);
    this._GlobalDataService.checkStepCompletion();
  }

}

